import React from 'react';
import { useTranslation } from 'react-i18next';
import { TicketCardHeader } from '../../../detail/components/ticket-card/ticketCard';
import SubSection from './SubSection';
import css from '../../styles.module.css';

export default function OrderSummary({ form }) {
    const { t } = useTranslation();
    const selectedCount = form.selected_rates.length;
    const attendeesCount = form.orders.length;

    return (
        <TicketCardHeader className={css['summary-header']}>
            <div className={css['summary-title']}>
                <h3>{t('attendees.invitations.summary.title')}</h3>
            </div>
            <div className={css['summary-header-subsection']}>
                <SubSection name={t('attendees.invitations.summary.rates')} content={selectedCount} />

                <SubSection name={t('attendees.invitations.summary.attendees')} content={attendeesCount} />
            </div>
        </TicketCardHeader>
    );
}
